var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 3,
    fill: "#161618"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.2381C3 3.55431 3.55431 3 4.2381 3C4.92188 3 5.47619 3.55431 5.47619 4.2381C5.47619 4.8242 5.06893 5.31518 4.52196 5.4435C4.52318 5.45422 4.52381 5.46514 4.52381 5.47619V8.52381C4.52381 8.53486 4.52318 8.54579 4.52196 8.5565C5.06893 8.6848 5.47619 9.17581 5.47619 9.7619C5.47619 10.4457 4.92188 11 4.2381 11C3.55431 11 3 10.4457 3 9.7619C3 9.17581 3.40726 8.6848 3.95423 8.5565C3.95301 8.54579 3.95238 8.53486 3.95238 8.52381V5.47619C3.95238 5.46514 3.95301 5.45422 3.95423 5.4435C3.40726 5.31518 3 4.8242 3 4.2381ZM4.2381 3.57143C3.8699 3.57143 3.57143 3.8699 3.57143 4.2381C3.57143 4.60629 3.8699 4.90476 4.2381 4.90476C4.60629 4.90476 4.90476 4.60629 4.90476 4.2381C4.90476 3.8699 4.60629 3.57143 4.2381 3.57143ZM4.2381 9.09524C3.8699 9.09524 3.57143 9.39371 3.57143 9.7619C3.57143 10.1301 3.8699 10.4286 4.2381 10.4286C4.60629 10.4286 4.90476 10.1301 4.90476 9.7619C4.90476 9.39371 4.60629 9.09524 4.2381 9.09524Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47665 8.55695C8.9306 8.6859 8.52427 9.17646 8.52427 9.7619C8.52427 10.4457 9.0786 11 9.76237 11C10.4461 11 11.0005 10.4457 11.0005 9.7619C11.0005 9.17646 10.5941 8.6859 10.0481 8.55695V5.38095C10.0481 4.59197 9.4085 3.95238 8.61951 3.95238H7.07121L7.53582 3.48774C7.6474 3.37617 7.6474 3.19526 7.53582 3.08368C7.42424 2.97211 7.24336 2.97211 7.13178 3.08368L6.17939 4.03606C6.06781 4.14764 6.06781 4.32855 6.17939 4.44012L7.13178 5.39251C7.24336 5.50408 7.42424 5.50408 7.53582 5.39251C7.6474 5.28093 7.6474 5.10002 7.53582 4.98844L7.07121 4.52381H8.61951C9.09288 4.52381 9.47665 4.90756 9.47665 5.38095V8.55695ZM9.0957 9.7619C9.0957 9.39371 9.39418 9.09524 9.76237 9.09524C10.1306 9.09524 10.429 9.39371 10.429 9.7619C10.429 10.1301 10.1306 10.4286 9.76237 10.4286C9.39418 10.4286 9.0957 10.1301 9.0957 9.7619Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.48fdae8a146c7b29c288bbf775dae337.svg";
export { ForwardRef as ReactComponent };